module.exports = __webpack_public_path__ + "87e46c1d666d4c3aaca7a597c51d6e9a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/electric-guitar.png
// module id = 1610
// module chunks = 0